<template>
  <b-container fluid class="news">
    <b-card no-body v-for="(artikel,ix) in news" v-bind:key="artikel.id" class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab" :ref="artikel.id">
        <b-btn
          block
          href="#"
          v-b-toggle="artikel.id.toString()"
          variant="primary"
        >{{ artikel.title }}</b-btn>
      </b-card-header>
      <b-collapse
        :id="artikel.id.toString()"
        :visible="(conID === 0 && ix === 0) || (conID > 0 && artikel.id == conID)"
        :accordion="'news'+domID"
        role="tabpanel"
        v-on:show="collapseIsShowing(artikel.title)"
      >
        <!-- typeof artikel.id = number, typeof conID = string !? -->
        <b-card-body v-html="artikel.text"></b-card-body>
      </b-collapse>
    </b-card>
  </b-container>
</template>

<script>
export default {
  name: "news",
  props: {
    domID: Number, // check explizit property casting on router /news/props = fn   => https://forum.vuejs.org/t/router-vue-props-type-number-didnt-cast/25774
    conID: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {};
  },
  computed: {
    news() {
      return this.$store.state.newsStore.news;
    }
  },
  methods: {
    scrollTo(ref) {
      var element = this.$refs[ref][0];
      element.scrollIntoView();
    },
    collapseIsShowing(title) {
      this.$ga.page(this.$route.path + "/" + encodeURI(title));
    }
  },
  created() {
    let self = this;
    this.$nextTick(async function() {
      self.$store.commit("setNews", []);
      await self.$store.dispatch("loadNews", self.domID);
    });
  },
  mounted() {},
  updated() {
    if (this.conID > 0) {
      this.scrollTo(this.conID);
    }
  },
  components: {}
};
</script>

<style lang="scss">
.news a.btn {
  overflow: hidden;
}
</style>